/*** IMPORTS FROM imports-loader ***/
var define = false;

'use strict';

/** @type {import('./isNaN')} */
module.exports = Number.isNaN || function isNaN(a) {
	return a !== a;
};

